import React, { useRef, useState } from 'react'
import emailjs from '@emailjs/browser';

function Contact() {
    const form = useRef();
    const [formValues, setFormValues] = useState({
        name: "",
        email: "",
        message: ""
    });

    const sendEmail = (e) => {
        e.preventDefault(); // prevents the page from reloading when you hit “Send”

        emailjs.sendForm('service_1nzzfcm', 'template_2tv9din', form.current, 'VSIY_D53fw99T3kbi')
            .then(() => {
                // show the user a success message
                alert("Message sent successfully.")
            }, () => {
                // show the user an error
                alert("Error occured while sending the message.")
            });

        setFormValues({...formValues, name: "", email: "", message: ""});
    };

    return (
        <div name='contact' className='w-full h-screen bg-[#0a192f] text-gray-300 flex justify-center items-center p-4'>
            <form ref={form} className='flex flex-col max-w-[600px] w-full items-center'>
                <div className='text-center'>
                    <p className='text-4xl font-bold inline border-b-4 border-pink-600'>Contact</p>
                    <p className='text-2xl font-md my-7'>Let's make something great</p>
                </div>
                <div className='flex flex-col max-w-[600px] w-full items-center'>
                    <input className='my-2 p-2 bg-[#ccd6f6] w-[80%] m-auto text-black' type="text" placeholder='Name' name='name' value={formValues.name} onChange={(e) =>
                        setFormValues({ ...formValues, name: e.target.value })
                    } />
                    <input className='my-2 p-2 bg-[#ccd6f6] w-[80%] m-auto text-black' type="email" placeholder='Email' name='email' value={formValues.email} onChange={(e) =>
                        setFormValues({ ...formValues, email: e.target.value })} />
                    <textarea className='my-2 bg-[#ccd6f6] p-2 w-[80%] m-auto resize-none text-black' name="message" rows="5" placeholder='Message' value={formValues.message} onChange={(e) =>
                        setFormValues({ ...formValues, message: e.target.value })} ></textarea>
                    <button onClick={sendEmail} className='text-white w-[40%] m-auto border-2 py-3 my-5 hover:bg-pink-600 hover:border-pink-600 hover:transition-ease duration-300'>Let's Collaborate</button>
                </div>
            </form>
        </div>
    )
}

export default Contact